var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc ba b--dashed b--yellow pointer",staticStyle:{"padding-top":"25%","padding-bottom":"25%"},on:{"click":function($event){_vm.$emit('click')}}},[_c('img',{staticClass:"w-50",attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }